import { CustomElement, attachShadowTemplate } from '@tylertech/forge-core';
import { BaseComponent, IBaseComponent } from '@tylertech/forge';
import { FOOTER_ITEM_CONSTANTS } from './footer-item-constants';

const defaultTemplate = '<template><div class=\"forge-footer-item\" part=\"root\"><slot></slot></div></template>';
const styles = '.forge-footer-item{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:Roboto,sans-serif;font-family:var(--mdc-typography-body2-font-family, var(--mdc-typography-font-family, Roboto, sans-serif));font-size:.875rem;font-size:var(--mdc-typography-body2-font-size, .875rem);line-height:1.25rem;line-height:var(--mdc-typography-body2-line-height, 1.25rem);font-weight:400;font-weight:var(--mdc-typography-body2-font-weight,400);letter-spacing:.0178571429em;letter-spacing:var(--mdc-typography-body2-letter-spacing, .0178571429em);text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-body2-text-decoration,inherit);text-decoration:var(--mdc-typography-body2-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-body2-text-transform,inherit);color:#fff;color:var(--forge-footer-theme-on-background,#fff);line-height:1.375rem;display:-webkit-inline-box;display:inline-flex;word-break:normal}.forge-footer-item ::slotted(*){-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:Roboto,sans-serif;font-family:var(--mdc-typography-body2-font-family, var(--mdc-typography-font-family, Roboto, sans-serif));font-size:.875rem;font-size:var(--mdc-typography-body2-font-size, .875rem);line-height:1.25rem;line-height:var(--mdc-typography-body2-line-height, 1.25rem);font-weight:400;font-weight:var(--mdc-typography-body2-font-weight,400);letter-spacing:.0178571429em;letter-spacing:var(--mdc-typography-body2-letter-spacing, .0178571429em);text-decoration:inherit;-webkit-text-decoration:var(--mdc-typography-body2-text-decoration,inherit);text-decoration:var(--mdc-typography-body2-text-decoration,inherit);text-transform:inherit;text-transform:var(--mdc-typography-body2-text-transform,inherit);color:#fff;color:var(--forge-footer-theme-on-background,#fff);line-height:1.375rem;margin:0}.forge-footer-item ::slotted(a){text-decoration:none}.forge-footer-item ::slotted(a:visited){color:#fff;color:var(--forge-footer-theme-on-background,#fff)}.forge-footer-item ::slotted(a:focus),.forge-footer-item ::slotted(a:hover){text-decoration:underline}:host{display:inline;-webkit-box-sizing:border-box;box-sizing:border-box}:host([hidden]){display:none}';

export interface IFooterItemComponent extends IBaseComponent {}


declare global {
  interface HTMLElementTagNameMap {
    'forge-footer-item': IFooterItemComponent;
  }
}

/**
 * The custom element class behind the `<forge-footer-item>` element.
 * 
 * @tag forge-footer-item
 */
@CustomElement({
  name: FOOTER_ITEM_CONSTANTS.elementName
})
export class FooterItemComponent extends BaseComponent implements IFooterItemComponent {

  constructor() {
    super();
    attachShadowTemplate(this, defaultTemplate, styles);
  }

  public connectedCallback(): void {
    this._setRole();
  }

  private _setRole(): void {
    if (!this.hasAttribute('role')) {
      this.setAttribute('role', 'listitem');
    }
  }
}
